"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IS = void 0;
exports.IS = {
    belongsToEU: false,
    belongsToEurope: true,
    subdivisions: {
        'IS-1': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-GAR': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-HAF': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-KJO': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-KOP': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-MOS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-RKV': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SEL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-2': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-GRN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-RKN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SDN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SVG': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-3': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-AKN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-BOG': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-DAB': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-EOM': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-GRU': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-HEL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-HVA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SKO': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SNF': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-STY': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-4': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-ARN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-BOL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-ISA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-KAL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-RHH': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SDV': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-STR': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-TAL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-VER': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-5': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-AKH': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-BLO': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-HUT': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-HUV': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SKG': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SSF': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SSS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-6': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-AKU': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-DAV': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-EYF': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-FJL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-GRY': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-HRG': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-LAN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-NOR': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SBH': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SBT': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SKU': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-THG': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-TJO': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-7': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-FJD': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-FLR': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-MUL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SHF': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-VOP': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-8': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-ASA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-BLA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-FLA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-GOG': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-HRU': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-HVE': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-MYR': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-RGE': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-RGY': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SFA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SKF': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SOG': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-SOL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'IS-VEM': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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